// extracted by mini-css-extract-plugin
module.exports = {"campaignHeader":"CampaignHeader_campaignHeader__2QgwX"};